import React from 'react';

const adSlots = {
  'd2planner-left': {
    sizes: [["300", "600"], ["160", "600"]],
  },
  'd2planner-right': {
    sizes: [["300", "600"], ["160", "600"]],
  },
  'd2planner-tab-guide': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
  'd2planner-tab-equipment': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
  'd2planner-tab-character': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
  'd2planner-tab-calculations-1': {
    sizes: [["320", "50"], ["320", "100"]],
  },
  'd2planner-tab-calculations-2': {
    sizes: [["320", "50"], ["320", "100"]],
  },
  'd2planner-tab-save-load': {
    sizes: [["300", "250"], ["320", "50"], ["320", "100"]],
  },
};

export default React.memo(function AdUnit({ id, ...props }) {
  React.useEffect(() => {
    window.nitroAds?.createAd(id, {
      refreshLimit: 10,
      refreshTime: 90,
      renderVisibleOnly: true,
      refreshVisibleOnly: true,
      report: {enabled: false},
      sizes: adSlots[id].sizes,
    });
  }, [id]);
  return <div id={id} {...props}/>;
});
